import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {Feature} from "../../gd/access-control/feature-access/const";
import {SettingsSection, SettingsSectionTitleDict} from "../../../app/settings/@const";

// const debug = "SupportTicketModule"
const debug = false

export class SupportTicketModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.SUPPORT_TICKET, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                    = "Support Ticket System"
        this.description             = "The Support Ticket System module offers an efficient way to manage customer inquiries and issues. It streamlines the process of ticket creation, assignment, and resolution, ensuring timely and effective support. Ideal for enhancing customer service and support workflows."
        this.svgIcon                 = "isvg-ticket-system"
        this.settingsMenuTopCategory = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel               = SettingsSectionTitleDict[SettingsSection.CRM]
        this.settingsUrl             = "settings/support-tickets"


        this.feature                 = Feature.SUPPORT_TICKET
        this.validateFeature()
    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}
